// extracted by mini-css-extract-plugin
module.exports = {"item":"Card_item__sQ8D+","content":"Card_content__ek3qq","img":"Card_img__iJ8S7","video":"Card_video__k3mhb"};